/* eslint-disable import/no-cycle */
import Vue from 'vue';
import Vuex from 'vuex';

// eslint-disable-next-line import/no-cycle
import app from './modules/app';
import auth from './modules/auth.js';
import user from './modules/user';
import loading from './modules/loading';
import filterDate from './modules/filterDate';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    app,
    auth,
    user,
    loading,
    filterDate,
  },
});
